import { AxiosService } from '../../services/axiosService';

export const getCountriesApi = () => {
  return AxiosService.get('country');
}
